import React, {useContext} from 'react';
import SelectInput from './SelectInput'
import {FormContext} from '../FormEngine';
import {useGoodDaysFormulary} from '../DataFetcher';
import Loader from '../../General/Loader';
import {isJsonString} from '../../Helpers/Calculations';

const GoodDaysFormularySelectInput = props => {
    const { data } = props;
    const ctx = useContext(FormContext);

    const applicationId = ctx.meta.applicationId;
    const diagnosisId = ctx.meta.diagnosisId;
    const insuranceClassId = ctx.meta.insuranceClassId;
    const {gooddaysFormulary, isLoading, isError} = useGoodDaysFormulary(applicationId, diagnosisId, insuranceClassId, ctx.gtr);

    if (isError) return 'Error retrieving Formulary';
    if(isLoading) return <Loader />;

    //need to ensure that if the useGoodDaysFormulary hook fails (e.g. can't authenticate with the HUB), that the options and values are still arrays (iterable)
    const formularyOptions = gooddaysFormulary ? gooddaysFormulary.map(c => c.name) : [];
    const formularyValues = gooddaysFormulary ? gooddaysFormulary.map(c => JSON.stringify(c)) : [];

    //pre-select saved answer or selected drug
    var selection = '';
    if(data === null) selection = null;
    else {
        selection = isJsonString(data) ? JSON.parse(data).name.toLowerCase() : data.toLowerCase();
    }
    const selectionValue = (gooddaysFormulary??[]).find(f => f.name.toLowerCase() === selection);
    const value = selectionValue ? JSON.stringify(selectionValue) : null;

    const myProps = {
        ...props,
        def: {
            ...props.def,
            options: [ ...formularyOptions],
            values: [ ...formularyValues],
        },
        data: value,
        name: 'gooddaysforumularyselectinput_de'
    };

    return <SelectInput {...myProps}/>
}


export default GoodDaysFormularySelectInput;
